const EMAIL_RE = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export function validateEmail(email) {
  const trimmed = email.trim();
  if (!trimmed) return "Email address is required.";
  // eslint-disable-next-line no-control-regex
  if (/[^\x00-\x7F]/.test(trimmed)) {
    return "Please check the email address. It contains an accented character. Enter the email exactly as it appears in the member\u2019s email account.";
  }
  if (!EMAIL_RE.test(trimmed)) return "Please enter a valid email address.";
  return null;
}
